



























import {Component, Vue} from 'vue-property-decorator';
import Card from '@c/Card.vue';
import {PModuleWithMeasurements} from '@/views/system/modules/interfaces';
import {pmoduleStoresByTypeMap} from '@/views/system/modules/configurate';
import {PModuleType} from '@/enums/configs';
import {PModuleStoreModule} from '@/store/modules/entities/pmodules/interfaces';
import Loading from '@c/controls/Loading.vue';
import TableLastDBBoundaryRecords from '@/components/system/developerInfo/TableLastDBBoundaryRecords.vue';

@Component({
  components: {
    Card,
    TableLastDBBoundaryRecords,
    Loading,
  },
})
export default class PModuleEventBoundaryPassed extends Vue {
  // Программный модуль
  pmodule: PModuleWithMeasurements | null = null;

  // Показатели загрузки данных и ошибки
  loading = true;
  error = false;

  event: {type: string; description: string} = {
    type: 'boundary_passed',
    description: 'выход за границу (событие)',
  };

  // Получить хранилище
  get apiStore(): PModuleStoreModule {
    return (pmoduleStoresByTypeMap.get(
      ((this as any).$route.meta.type as any) as PModuleType,
    ) as any) as PModuleStoreModule;
  }

  async created() {
    try {
      const {data} = await this.apiStore.getById(this.$route.params.id);
      this.pmodule = data as PModuleWithMeasurements;

      if (!this.pmodule) return;
    } catch {
      this.error = true;
    } finally {
      this.loading = false;
    }
  }
}
